export const getters = {
  LIST: (state) => state.list,
  PAGINATION: state => state.pagination,
  BY_TEAM_ID: state => state.byTeamId,
}
